import Element from "../element";
import initListbox from "./collapsible-listbox";
import DOMHelper from "../../../lib/dom-helper";

export default class Select extends Element {
	constructor(props) {
		super(props);

		this.name = props.name || null;
		this.value = null;
		this.listboxController = null;
		this.VALUE_CHANGE_EVENT = 'valueChange';

		this.init();
	}

	init() {
		this.$root = this.props.$root;

		if (!this.$root) {
			throw new Error('Root element is not defined!');
		}

		this.listboxController = initListbox(this.$root);

		super.init();
	}

	addEventListeners() {
		this.listboxController.listbox.$root.addEventListener('select', this.handleSelect.bind(this));
	}

	handleSelect() {
		this.value = this.listboxController.listbox.$root.dataset.selected;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	enableButton() {
		this.listboxController.listboxButton.$root.classList.remove('-disabled');
		this.listboxController.listboxButton.$root.removeAttribute('disabled');
	}

	disableButton() {
		this.listboxController.listboxButton.$root.classList.add('-disabled');
		this.listboxController.listboxButton.$root.setAttribute('disabled', true);
	}

	setInitialState() {
		this.listboxController.listbox.unselectActive();
		this.listboxController.listboxButton.setInitialContent();
		this.value = null;
		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	importOptions(options) {
		if (Array.isArray(options)) {
			options.forEach((option) => {
				if (option instanceof HTMLElement) {
					this.listboxController.listbox.$listboxOpts.append(option);
				}
			});
		} else if (typeof options === 'string') {
			this.listboxController.listbox.$listboxOpts.innerHTML = options.trim();
		}
	}

	removeOptions() {
		this.setInitialState();
		listbox.$listboxOpts.innerHTML = '';
	}

	addOptions(data) {
		if (!Array.isArray(data)) {
			throw new TypeError('Select: Data must be an array of objects with label, value props.');
		}

		data.forEach((item) => {
			if (typeof item.label === 'undefined' || typeof item.value === 'undefined') {
				throw new Error('Select: Label or value props is not defined.');
			}

			this.addOption(item.label, item.value);
		});
	}

	addOption(label, value) {
		if (typeof label === 'undefined' || typeof value === 'undefined') {
			throw new Error('Select: Label or value is not defined.');
		}

		this.listboxController.listbox.$listboxOpts.append(Select.createOption(label, value));
	}

	selectFirstOption() {
		const $firstOption = this.listboxController.listbox.$listboxOpts.querySelector('.listbox_option');

		if ($firstOption) {
			this.listboxController.listbox.selectOption($firstOption);
		}
	}

	selectOptionByValue(value) {
		const $option = this.listboxController.listbox.$listboxOpts.querySelector(`[data-value="${value}"]`);

		if ($option) {
			this.listboxController.listbox.selectOption($option);
		}
	}

	static createOption(label, value) {
		if (typeof label === 'undefined' || typeof value === 'undefined') {
			return null;
		}

		return DOMHelper.createElement('li', {
			text: label,
			attributes: {
				class: 'listbox_option',
				'data-value': value,
				role: 'option'
			}
		});
	}
}